module.exports = __webpack_public_path__ + "static/callsheets_mobile@2x-1d79c7bd1b4e75c5f84488fb2d739d2d.png";